module.exports = __webpack_public_path__ + "img/404.677f43e7.png";